import React from 'react';
import './css/AvailableWalletBalance.css';

/** The actual Withdrawal balance card, reused unchanged in other money panels.
 *  balanceWei is the already-fetched wallet balance, in native xDAI wei.
 */
export default function AvailableWalletBalance({ balanceWei = null, language = 'english', theme = 'light', context = 'withdraw' }) {
  const es = language === 'spanish';
  const t = (en, sp) => es ? sp : en;
  const raw = balanceWei == null ? NaN : Number(balanceWei);
  const balance = Number.isFinite(raw) && raw >= 0
    ? (raw / 1e18).toLocaleString(es ? 'es-ES' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : null;
  const note = context === 'transfer'
    ? t('xDAI balance before transfer fees', 'Saldo xDAI antes de las comisiones de transferencia')
    : context === 'borrowing'
      ? t('Available xDAI; credit-line availability is separate', 'xDAI disponible; el crédito disponible se muestra por separado')
      : t('xDAI balance before withdrawal fees', 'Saldo xDAI antes de las comisiones de retiro');
  return <div className={'tbp-crypto__wallet-balance' + (theme === 'light' ? '' : ' is-dark')}
    aria-label={t('Available Blender Wallet Balance', 'Saldo Disponible de Cartera Blender')}>
    <span>{t('Available in Blender Wallet', 'Disponible en tu Cartera Blender')}</span>
    <strong>{balance === null ? '—' : balance} <small>USD</small></strong>
    <small>{note}</small>
  </div>;
}
